export const GraphLabel = (props: any) => {
    const { index, x, y, stroke, size, value } = props;

    return (
        <text x={x} y={y} dy={-8} fill={stroke} fontSize={size === 'large' ? 14 : 10} textAnchor="middle">
            {index !== 0 ? value : ''}
        </text>
    );
};
